import { useTranslation } from 'react-i18next';
import { Badge } from '@repo/ui/src/components/ui/badge';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'muted';

// One calm, semantic status system for every invoice surface (list, detail,
// client tab, workbench). Green = settled, amber = money that still needs
// attention, red = overdue, neutral = not-yet-sent. OVERDUE is derived from
// dueDate + a payable status and always wins over the stored status.
function variantFor(status: string, isOverdue?: boolean): BadgeVariant {
  if (isOverdue) return 'danger';
  switch (status) {
    case 'PAID':
      return 'success';
    case 'PENDING':
    case 'SENT':
    case 'PARTIAL':
      return 'warning';
    default:
      return 'muted';
  }
}

export function InvoiceStatusBadge({
  status,
  isOverdue,
  className,
}: {
  status: string;
  isOverdue?: boolean;
  className?: string;
}) {
  const { t } = useTranslation('invoices');
  const label = isOverdue ? t('status.OVERDUE') : t(`status.${status}`);
  return (
    <Badge variant={variantFor(status, isOverdue)} className={className}>
      {label}
    </Badge>
  );
}
